import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { compose, branch, renderNothing } from 'recompose';

import ServiceDetails from './ServiceDetails';
import { nullFunc } from '../../utils/helpers';
import withGiftCardLink from '../../giftCard/hoc/withGiftCardLink';
import hideWithoutGiftCardSales from '../../giftCard/hoc/hideWithoutGiftCardSales';
import WithKioskProp from '../../hoc/WithKioskProp';

const service = { name: 'Gift Card' };

const GiftCardService = ({ link }) => (
  <div className="layout__item u-1/2-medium-and-up u-1/3-extralarge-and-up">
    <Link
      className="c-select-box c-select-box--small c-select-box--no-hover u-text-center u-bg-black-2"
      to={link}
    >
      <ServiceDetails service={service} />
    </Link>
  </div>
);

GiftCardService.propTypes = {
  link: PropTypes.string.isRequired,
};

GiftCardService.defaultProps = {
  generateUrlString: nullFunc,
  onClick: nullFunc,
};

export default compose(
  WithKioskProp,
  hideWithoutGiftCardSales,
  withGiftCardLink,
  branch(
    props => props.kiosk,
    renderNothing,
  ),
)(GiftCardService);



// WEBPACK FOOTER //
// ./src/app/services/components/GiftCardService.jsx